/** * 系统管理 字典数据 */
<template>
  <div>
    <div class="dict-data-header">
      <span class="dict-data-title">
        字典数据 - {{ dictName || dictType }}
      </span>
    </div>

    <div class="query-select">
      <el-form :inline="true" :model="queryParams" class="user-search">
        <el-form-item label="字典类型">
          <el-input v-model.trim="dictType" disabled></el-input>
        </el-form-item>
        <el-form-item label="数据标签">
          <el-input
            v-model.trim="queryParams.dictLabel"
            placeholder="请输入数据标签"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            v-model="queryParams.status"
            placeholder="请搜索状态"
            clearable
          >
            <el-option label="正常" value="0"></el-option>
            <el-option label="停用" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button plain round size="small"
          type="primary"
          icon="el-icon-search"
          @click="handleQuery"
          >查询</el-button
        >
        <el-button plain round size="small"
          type="warning"
          icon="el-icon-refresh-left"
          @click="resetQuery"
          >重置</el-button
        >
        <el-button plain round size="small"
          type="success"
          icon="el-icon-plus"
          @click="dialogShow('add')"
          >新增</el-button
        >
      </div>
    </div>

    <div class="main-table">
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        stripe
        header-cell-class-name="table-header"
        element-loading-text="拼命加载中"
        style="width: 100%;"
      >
        <el-table-column align="center" type="index" width="60" label="序号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="dictCode"
          label="字典编码"
          width="100"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="dictLabel"
          label="数据标签"
          min-width="140"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="dictValue"
          label="数据键值"
          min-width="140"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="dictSort"
          label="显示排序"
          width="100"
        >
        </el-table-column>
        <el-table-column align="center" prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '0' ? 'success' : 'info'">
              {{ scope.row.status === "0" ? "正常" : "停用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="remark"
          label="备注"
          min-width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          label="创建时间"
          min-width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column align="center" label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button plain round size="small"
              type="warning"
              @click="dialogShow('edit', scope.row)"
              >编辑</el-button
            >
            <el-button plain round size="small"
              type="danger"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="pageparm.pageNum"
        :page-size="pageparm.pageSize"
        layout="total, prev, pager, next"
        :total="totals"
      >
      </el-pagination>
    </div>

    <DictDataForm ref="formRef" @success="handleDictDataSuccess"></DictDataForm>
  </div>
</template>

<script>
import { getDictDataList, deleteDictData } from "@/api/system";
import { loadDictCache } from "@/utils/dict";
import DictDataForm from "./DictDataForm.vue";

export default {
  components: {
    DictDataForm
  },
  data() {
    return {
      loading: false,
      listData: [],
      totals: 0,
      dictType: "",
      dictName: "",
      pageparm: {
        pageNum: 1,
        pageSize: 10
      },
      queryParams: {
        dictLabel: "",
        status: ""
      }
    };
  },
  watch: {
    "$route.query": {
      handler() {
        this.initFromRoute();
        this.getList();
      },
      deep: true
    }
  },
  created() {
    this.initFromRoute();
    this.getList();
  },
  methods: {
    initFromRoute() {
      this.dictType = this.$route.query.dictType || "";
      this.dictName = this.$route.query.dictName || "";
      if (!this.dictType) {
        this.$router.replace({ path: "/system/dict" });
      }
    },
    goBack() {
      this.$router.push({ path: "/system/dict" });
    },
    async getList() {
      if (!this.dictType) return;
      this.loading = true;
      const params = {
        pageNum: this.pageparm.pageNum,
        pageSize: this.pageparm.pageSize,
        dictType: this.dictType,
        dictLabel: this.queryParams.dictLabel || undefined,
        status: this.queryParams.status || undefined
      };
      try {
        const result = await getDictDataList(params);
        this.listData = (result.data && result.data.rows) || [];
        this.totals = (result.data && result.data.total) || 0;
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    async handleDictDataSuccess() {
      await this.getList();
      await loadDictCache();
    },
    handleCurrentChange(val) {
      this.pageparm.pageNum = val;
      this.getList();
    },
    handleQuery() {
      this.pageparm.pageNum = 1;
      this.getList();
    },
    resetQuery() {
      this.queryParams = {
        dictLabel: "",
        status: ""
      };
      this.pageparm.pageNum = 1;
      this.getList();
    },
    dialogShow(type, row = {}) {
      this.$refs.formRef.open(type, row, this.dictType);
    },
    async handleDelete(row) {
      try {
        await this.$confirm(
          `确定删除字典数据「${row.dictLabel}」吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        );
        await deleteDictData(row.dictCode);
        this.$message.success("删除成功");
        this.getList();
      } catch (e) {}
    }
  }
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.dict-data-header {
  display: flex;
  align-items: center;
  margin-top: 12px;
  padding: 0 4px;
}
.dict-data-title {
  margin-left: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}
</style>



// WEBPACK FOOTER //
// src/views/system/Dict/data/index.vue